export const CurrentConfig = {
    verboseLogging: false,
};

export const enableVerboseLogging = function() {
    CurrentConfig.verboseLogging = true;
};



//////////////////
// WEBPACK FOOTER
// /Users/Jovan/TitanNanoDE/node_modules/@af-modules/databinding/lib/Config.js
// module id = 29
// module chunks = 0